import React from 'react';
import { Check, ChevronDown } from 'lucide-react';
import { useLocalization } from '../../providers/LocalizationProvider';
import { cn } from '../../lib/utils/cn';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './DropdownMenu';
import { Button } from './Button';

export default function LanguageSelector() {
  const { language, changeLanguage, availableLanguages } = useLocalization();
  
  const currentLanguage = availableLanguages.find(lang => lang.code === language);

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2">
          <span className={currentLanguage?.flag}></span>
          <span className="hidden sm:inline font-medium">
            {currentLanguage?.name}
          </span>
          <ChevronDown className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {availableLanguages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            className={cn(
              "flex items-center gap-3 cursor-pointer",
              language === lang.code && "bg-accent"
            )}
          >
            <span className={lang.flag}></span>
            <span className="flex-1 text-sm font-medium">
              {lang.name}
            </span>
            {language === lang.code && (
              <Check className="h-4 w-4" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}